import Footer from "../../components/Footer";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import {contactUs} from "../../api";

export const ContactUs = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        topic: '',
        description: ''
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you can integrate with your backend or email service
        contactUs({
            email: formData.email,
            name: formData.name,
            topic: formData.topic,
            description: formData.description
        }).then(result => {
            alert('Thank you for contacting us! We will get back to you soon.');
            setFormData({ name: '', email: '', topic: '', description: '' });
        })
    };

    return <div className="App">
        <nav className="navbar">
            <div className="nav-container">
                <div className="nav-logo">
                    <h2>AI Cards: Learn & Speak</h2>
                </div>

                <div className="nav-links">
                    <button onClick={() => navigate('/')} className="nav-link">Home</button>
                </div>
            </div>
        </nav>

        <section className="contact-section">
            <div className="container">
                <div className="contact-layout">
                    <h2>Contact Us</h2>
                    <p>Have a question or feedback? We'd love to hear from you.</p>

                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder="Your name"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Contact Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="your@email.com"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="topic">Topic</label>
                            <select
                                id="topic"
                                name="topic"
                                value={formData.topic}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>Select a topic</option>
                                <option value="general">General Inquiry</option>
                                <option value="feedback">Feedback</option>
                                <option value="support">Technical Support</option>
                                <option value="business">Business Proposal</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="description">Description</label>
                            <textarea
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                required
                                placeholder="How can we help you?"
                                rows="5"
                            />
                        </div>
                        <button type="submit" className="submit-button">Send Message</button>
                    </form>
                </div>
            </div>
        </section>

        <Footer />
    </div>
}
